import React from 'react';
import { FaLightbulb, FaRocket, FaUsers, FaAward } from 'react-icons/fa';

const timelineEvents = [
  {
    year: '2022',
    title: 'Solar Tools Doğuyor',
    description: [
      'SolarTools fikri ortaya çıktı',
      'İlk prototip çalışmaları başladı',
      'Ar-Ge ekibi kuruldu'
    ],
    icon: <FaLightbulb className="text-2xl" />
  },
  {
    year: '2023',
    title: 'Solar Tools Hayata Geçiyor',
    description: [
      'Web platformunun ilk sürümü geliştirildi',
      'Mobil uygulama beta devreye alındı',
      'İlk demo kurulumları yapıldı'
    ],
    icon: <FaRocket className="text-2xl" />
  },
  {
    year: '2024',
    title: ' Gelişmeler Devam Ediyor',
    description: [
      'KOSGEB Ar-Ge Ür-Ge desteği alındı',
      'Log cihazının ilk sürümü devreye alındı',
      'Çukurova Teknokent şubesi açıldı'
    ],
    icon: <FaUsers className="text-2xl" />
  },
  {
    year: '2025',
    title: 'Hedeflerimiz Büyüyor',
    description: [
      'Tübitak 1832 programı kapsamında destek almaya hak kazandık',
      'Web platformu yeni sürümü geliştiriliyor',
      'Yapay zeka destekli Güneş enerjisi Üretim tahmini yapılıyor'
    ],
    icon: <FaAward className="text-2xl" />
  }
];

export default function Timeline() {
  return (
    <section className="py-16 bg-gradient-to-br from-white via-[var(--color-background)] to-white">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-4xl font-bold text-center text-[var(--color-primary)] mb-16">
          Yolculuğumuz
        </h2>

        <div className="relative">
          {/* Timeline çizgisi */}
          <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-[var(--color-primary)] rounded"></div>

          <div className="relative">
            {timelineEvents.map((event, index) => (
              <div
                key={index}
                className={`flex items-center justify-between mb-16 ${
                  index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'
                }`}
              >
                {/* Sol veya sağ içerik */}
                <div className={`w-5/12 ${index % 2 === 0 ? 'text-right' : 'text-left'}`}>
                  <div className={`p-6 bg-white rounded-xl shadow-lg transform transition-all duration-300 hover:scale-105 ${
                    index % 2 === 0 ? 'mr-8' : 'ml-8'
                  }`}>
                    <div className="text-[var(--color-secondary)] font-bold text-2xl mb-2">
                      {event.year}
                    </div>
                    <h3 className="text-xl font-semibold text-[var(--color-primary)] mb-4">
                      {event.title}
                    </h3>
                    <ul className={`space-y-2 ${index % 2 === 0 ? 'text-right' : 'text-left'} text-[var(--color-black)]`}>
                      {event.description.map((item, i) => (
                        <li 
                          key={i}
                          className="flex items-center gap-2"
                        >
                          {index % 2 === 0 && <div className="flex-1" />}
                          <span className="text-[var(--color-secondary)]">•</span>
                          <span>{item}</span>
                          {index % 2 === 1 && <div className="flex-1" />}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Orta nokta */}
                <div className="absolute left-1/2 transform -translate-x-1/2 w-12 h-12 rounded-full bg-[var(--color-primary)] border-4 border-white shadow flex items-center justify-center text-white">
                  {event.icon}
                </div>

                {/* Boş alan (simetri için) */}
                <div className="w-5/12"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
} 